import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from "react";
import DemoModal from "../components/DemoModal";

type Ctx = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

const DemoModalCtx = createContext<Ctx | null>(null);

export function DemoModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setOpen] = useState(false);
  const open = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);

  return (
    <DemoModalCtx.Provider value={{ isOpen, open, close }}>
      {children}
      <DemoModal isOpen={isOpen} onClose={close} />
    </DemoModalCtx.Provider>
  );
}

export function useDemoModal() {
  const ctx = useContext(DemoModalCtx);
  if (!ctx) {
    throw new Error("useDemoModal must be used inside <DemoModalProvider>");
  }
  return ctx;
}
